import React, { useState } from "react";
import config from "lib/fr-config";
import OutfitListView from "presentational/common/outfitUnit/OutfitListView";
import PickAndBookmarkFolderDropdownButtonView from "presentational/portfolio/PickAndBookmarkFolderDropdownButtonView";
import PickAndBookmarkFolderOptModalView from "presentational/portfolio/PickAndBookmarkFolderOptModalView";
import IconButtonView from "presentational/common/IconButtonView";
import { getDeviceType } from "lib/deviceInfo";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const MORE_BTN_TYPE = config.iconDesign.moreButton;

const cssXL = {
  dropdownWrapper: {
    marginTop:
      desktopCss.paddingBetweenTextButton -
      desktopCss.standardPaddingBetweenContent,
    marginBottom: desktopCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }
};

const cssXS = {
  dropdownWrapper: {
    marginTop:
      mobileCss.paddingBetweenTextButton -
      mobileCss.standardPaddingBetweenContent,
    marginBottom: mobileCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }
};

PickListView.propTypes = {
  list: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isEnd: PropTypes.bool.isRequired,
  pickFolderList: PropTypes.array.isRequired,
  selectedFolderHash: PropTypes.string,
  onFolderChange: PropTypes.func.isRequired,
  callNextListFn: PropTypes.func.isRequired,
  onFolderCreateBtnSubmit: PropTypes.func.isRequired,
  onFolderEditBtnSubmit: PropTypes.func.isRequired,
  onFolderDeleteBtnSubmit: PropTypes.func.isRequired
};

function PickListView(props) {
  const {
    list,
    isLoading,
    isEnd,
    pickFolderList,
    selectedFolderHash,
    onFolderChange,
    callNextListFn,
    onFolderCreateBtnSubmit,
    onFolderEditBtnSubmit,
    onFolderDeleteBtnSubmit
  } = props;
  const [folderModalOpen, setFolderModalOpen] = useState(false);

  const deviceType = getDeviceType();
  const css = deviceType === "mobile" ? cssXS : cssXL;

  const getFolderList = () => {
    const returnArr = [];
    for (let i = 0; i < pickFolderList.length; i++) {
      const { hash, name } = pickFolderList[i];
      const text =
        hash === "all" ? <TXT name="msg_allOutfitOfDropdown" /> : name;

      returnArr.push({ value: hash, text });
    }
    return returnArr;
  };

  const getNowFolderInfo = () => {
    if (!selectedFolderHash) return {};

    for (let i = 0; i < pickFolderList.length; i++) {
      const { hash, name } = pickFolderList[i];
      if (selectedFolderHash === hash) {
        return { hash, name };
      }
    }
  };

  const handleOptBtnClick = () => {
    setFolderModalOpen(true);
  };

  const handleModalClose = () => {
    setFolderModalOpen(false);
  };

  return (
    <div>
      <div style={css.dropdownWrapper}>
        <PickAndBookmarkFolderDropdownButtonView
          type={"pickFolder"}
          folderList={getFolderList()}
          selectedItem={selectedFolderHash}
          onSelect={onFolderChange}
        />
        <IconButtonView
          type={MORE_BTN_TYPE}
          disableRightMargin
          onClick={handleOptBtnClick}
          buttonSize={"small"}
          fontSize={"small"}
        />
      </div>
      <OutfitListView
        list={list}
        isLoading={isLoading}
        isEnd={isEnd}
        callNextListFn={callNextListFn}
        emptyListText={<TXT name="msg_emptyListPick" />}
      />
      {!!selectedFolderHash && (
        <PickAndBookmarkFolderOptModalView
          open={folderModalOpen}
          nowFolderInfo={getNowFolderInfo()}
          onFolderCreateBtnSubmit={onFolderCreateBtnSubmit}
          onFolderEditBtnSubmit={onFolderEditBtnSubmit}
          onFolderDeleteBtnSubmit={onFolderDeleteBtnSubmit}
          onClose={handleModalClose}
        />
      )}
    </div>
  );
}

export default PickListView;
